"use strict"

import { getCartCount } from "../utils/cookies";

export default function () {
    const elements = document.querySelectorAll('.js-cart-status');

    if (!elements.length) {
        return false;
    }

    let cartCount = getCartCount();

    if (cartCount) {
        elements.forEach(element => {
            element.querySelector('.cart-number').innerText = cartCount;
        });
        document.body.classList.add('items-in-cart');
    } else {
        document.body.classList.remove('items-in-cart');
    }

}
